import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './FAQSection.css';

const FAQS = [
  {
    q: 'Cosa fare stasera nella mia città?',
    a: 'Su Happy Events trovi tutti gli eventi della sera: concerti, aperitivi, spettacoli teatrali, mostre d\'arte e feste. Attiva la geolocalizzazione o seleziona oggi nello slider dei giorni per vedere subito cosa fare stasera vicino a te — completamente gratis.',
  },
  {
    q: 'Come trovare eventi vicino a me?',
    a: 'Clicca su "Usa la mia posizione" per attivare la geolocalizzazione. Happy Events mostrerà solo gli eventi entro il raggio da te scelto (5–100 km), ordinati per distanza. Funziona su mobile e desktop.',
  },
  {
    q: 'Ci sono concerti stasera?',
    a: 'Happy Events aggrega ogni giorno centinaia di concerti in tutta Italia. Usa il filtro categoria "Musica" e seleziona oggi o stasera nello slider per vedere i concerti disponibili nella tua zona.',
  },
  {
    q: 'Cosa fare questo weekend?',
    a: 'Scorri lo slider dei giorni e seleziona sabato o domenica per vedere tutti gli eventi del weekend vicino a te: concerti, mercatini, mostre, spettacoli e feste. Filtra per categoria e distanza per trovare quello che fa per te.',
  },
  {
    q: 'Ci sono eventi gratuiti?',
    a: 'Sì! Happy Events è gratuito per tutti gli utenti e include moltissimi eventi a ingresso libero. Esplora la lista e usa il filtro categorie per trovare eventi gratuiti nella tua città.',
  },
  {
    q: 'Come partecipare a un evento?',
    a: 'Clicca sull\'evento per i dettagli completi, poi premi "Parteciperò". Puoi anche chattare con gli altri partecipanti nella community e trovare persone con interessi simili grazie al match automatico per città, età e interessi.',
  },
  {
    q: 'Cos\'è il Match Community?',
    a: 'Il Match Community è la funzione social di Happy Events. Dopo la registrazione puoi inserire i tuoi interessi, la tua città e la fascia d\'età. L\'algoritmo ti suggerisce altri utenti con passioni simili che parteciperanno agli stessi eventi — puoi mandargli una richiesta di contatto e organizzarvi insieme.',
  },
  {
    q: 'Come funziona il Match con altri utenti?',
    a: 'Vai sulla pagina di un evento e scorri la sezione "Chi partecipa". Se vuoi conoscere qualcuno, clicca su "Contatta" per inviargli una richiesta. Se accetta, riceverete entrambi una notifica via email e potrete coordinarvi per l\'evento.',
  },
  {
    q: 'Cos\'è la funzione "Prenota il tuo tavolo"?',
    a: '"Prenota il tuo tavolo" è la funzione che permette di prenotare un posto a sedere direttamente dalla pagina dell\'evento. È attivata dall\'organizzatore per gli eventi che la supportano: scegli il numero di posti, inserisci nome, email e note, e la tua richiesta arriverà direttamente al locale o all\'organizzatore.',
  },
  {
    q: 'Come faccio a prenotare un tavolo a un evento?',
    a: 'Apri la pagina dell\'evento e, se la prenotazione è disponibile, troverai il box "Prenota il tuo tavolo". Compila il modulo con il numero di posti desiderati e i tuoi contatti. Riceverai un\'email di conferma o rifiuto direttamente dall\'organizzatore.',
  },
  {
    q: 'La prenotazione del tavolo è garantita?',
    a: 'La richiesta viene inviata all\'organizzatore che la approva o rifiuta manualmente. Riceverai un\'email con l\'esito. Ti consigliamo di prenotare con anticipo per assicurarti il posto.',
  },
];

const FAQSection = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(null);
  const faqs = t('faq.items', { returnObjects: true });

  return (
    <section className="faq-root" aria-label="FAQ">
      <div className="faq-header">
        <span className="faq-eyebrow">{t('faq.eyebrow')}</span>
        <h2 className="faq-title">{t('faq.title')}</h2>
      </div>

      <div className="faq-list">
        {faqs.map((item, i) => (
          <div key={i} className={`faq-item${open === i ? ' open' : ''}`}>
            <button
              className="faq-question"
              onClick={() => setOpen(open === i ? null : i)}
              aria-expanded={open === i}
            >
              <span>{typeof item === 'object' ? item.q : item}</span>
              <span className="faq-chevron">{open === i ? '−' : '+'}</span>
            </button>
            {open === i && (
              <div className="faq-answer">
                <p>{typeof item === 'object' ? item.a : ''}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
